import { UserUpdateUseCase } from '../../../../application';

export default class UserUpdateService {

    async RequestData(event) {
        const data = await UserUpdateUseCase(event);
        return data;
    }
}
